import React, { Fragment } from 'react'
import TopBar from '../components/TopBar'
import SideBar from '../components/SideBar'
import BasePage from '../components/BasePage'
function SlideShow() {
  return (
    <div>
        
        
    <BasePage title="स्लाइड शो"

body={
    <Fragment>
       
    <div class="wrapper">
        <TopBar title="स्लाइड शो"/>
        <SideBar/>
        <div class="content-page">
            <div class="content">

                <div class="container-fluid">

                    
                    
                </div> 

            </div>

            <footer class="footer">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 text-center">
                            <script>document.write(new Date().getFullYear())</script> © Softech Foundation
                        </div>
                    </div>
                </div>
            </footer>

        </div>
    </div>
    </Fragment>
}

/>
</div>
  )
}

export default SlideShow